import React from 'react';
import deepEqual from 'fast-deep-equal';
import { constVoid, flow, option, pipe, remote } from '@code-expert/prelude';
import { useAsyncError } from './useAsyncError.js';
import { useDeepCompareEffect } from './useDeepCompare.js';
import { useRaceState } from './useRaceState.js';
export const useObservable = (fn, ...options) => {
    const [state, mkSetState] = useRaceState(remote.initial);
    const error = useAsyncError('in useObservable');
    const opts = options[0] ?? { props: undefined };
    const paramsO = 'propsO' in opts ? opts.propsO : option.some(opts.props);
    const { current: cache } = React.useRef({
        prevArgs: {},
    });
    let result = state;
    if (!deepEqual(paramsO, cache.prevArgs)) {
        cache.prevArgs = paramsO;
        error.reset();
        if (option.isNone(paramsO)) {
            if (!remote.isInitial(state)) {
                mkSetState()(remote.initial);
                result = remote.initial;
            }
        }
        else {
            if (!remote.isPending(state)) {
                mkSetState()(remote.pending);
                result = remote.pending;
            }
        }
    }
    useDeepCompareEffect(() => {
        const setState = mkSetState();
        return pipe(paramsO, option.fold(() => {
            if (!remote.isInitial(state))
                setState(remote.initial);
            return constVoid;
        }, (value) => {
            if (!remote.isPending(state))
                setState(remote.pending);
            const subscription = fn(value).subscribe({
                next: flow(remote.done, setState),
                error: error.abort,
            });
            return () => {
                subscription.unsubscribe();
            };
        }));
    }, [paramsO] /* eslint-disable-line react-hooks/exhaustive-deps */);
    error.raise();
    return result;
};
//# sourceMappingURL=useObservable.js.map